import {
  mechanismCategorySectors,
  isUniversalCategory,
} from '../../helpers/dataHelpers/mechanismCategories'
import { getSectorInfo } from '../../helpers/meetstandaard/sectorCatalog'

/**
 * Shows which sector(s) a mechanism category belongs to.
 *
 * Renders the raw meetstandaard slug (not the Dutch label) because that is the
 * identifier the taxonomy, the api and the benchmark all key on — the friendly
 * label sits in the tooltip. A category tagged '*' shows one neutral chip
 * instead of listing every sector.
 *
 * Purely presentational: it reads the taxonomy, never a stored document, so an
 * unknown category simply renders nothing.
 *
 * @param {object} props
 * @param {string} props.category - Taxonomy category key (e.g. 'financial_relief').
 */
const SectorTag = ({ category }) => {

    const tags = mechanismCategorySectors[category]

    if (!Array.isArray(tags) || tags.length === 0) return null

    if (isUniversalCategory(category)) {
        return (
            <span className='sector-tag sector-tag-all' title='Geldt voor elke sector'>
                alle sectoren
            </span>
        )
    }

    return (
        <>
            {tags.map((slug) => (
                <span key={slug} className='sector-tag' title={getSectorInfo(slug).label}>
                    {slug}
                </span>
            ))}
        </>
    )
}

export default SectorTag
